import { ReactComponent as calamari } from 'resources/images/calamari.svg';
import { ReactComponent as calamariLogo } from 'resources/images/calamariLogo.svg';
import { ReactComponent as manta } from 'resources/images/manta.svg';
import { ReactComponent as talisman } from 'resources/icons/talisman.svg';
import { ReactComponent as metamask } from 'resources/icons/metamask.svg';
import { ReactComponent as subwallet } from 'resources/icons/subwallet.svg';

// coin icons
import { ReactComponent as bitcoin } from 'resources/icons/coins/bitcoin-icon.svg';
import { ReactComponent as ethereum } from 'resources/icons/coins/ethereum-icon.svg';
import { ReactComponent as acala } from 'resources/icons/coins/acala-icon.svg';
import { ReactComponent as kusama } from 'resources/icons/coins/kusama-icon.svg';
import { ReactComponent as ausd } from 'resources/icons/coins/ausd-icon.svg';
import { ReactComponent as kar } from 'resources/icons/coins/kar-icon.svg';
import { ReactComponent as kbtc } from 'resources/icons/coins/kbtc-icon.svg';
import { ReactComponent as roc } from 'resources/icons/coins/roc-icon.svg';
import { ReactComponent as movr } from 'resources/icons/coins/movr-icon.svg';
import { ReactComponent as moonbeam } from 'resources/icons/coins/moonbeam-icon.svg';
import { ReactComponent as tether } from 'resources/icons/coins/tether-icon.svg';
import { ReactComponent as statemine } from 'resources/icons/coins/statemine-icon.svg';
import { ReactComponent as dai } from 'resources/icons/coins/dai-icon.svg';
import { ReactComponent as usdc } from 'resources/icons/coins/usdc-icon.svg';
import { ReactComponent as wbtc } from 'resources/icons/coins/wbtc-icon.svg';
import { ReactComponent as bnb } from 'resources/icons/coins/bnb-icon.svg';

// sidebar icons
import { ReactComponent as audit } from 'resources/icons/sidebar/audit.svg';
import { ReactComponent as close } from 'resources/icons/sidebar/close.svg';
import { ReactComponent as govern } from 'resources/icons/sidebar/govern.svg';
import { ReactComponent as pool } from 'resources/icons/sidebar/pool.svg';
import { ReactComponent as redeem } from 'resources/icons/sidebar/redeem.svg';
import { ReactComponent as swap } from 'resources/icons/sidebar/swap.svg';
import { ReactComponent as transact } from 'resources/icons/sidebar/transact.svg';

// widesite icons
import { ReactComponent as warningV2 } from 'resources/icons/warningV2.svg';
import { ReactComponent as token } from 'resources/icons/token-icon.svg';
import { ReactComponent as deposit } from 'resources/icons/deposit-icon.svg';
import { ReactComponent as rowDown } from 'resources/icons/rowdown-icon.svg';
import { ReactComponent as rowDownWhite } from 'resources/icons/row-down-white.svg';
import { ReactComponent as coin } from 'resources/icons/coin-icon.svg';
import { ReactComponent as wallet } from 'resources/icons/wallet-icon.svg';
import { ReactComponent as clock } from 'resources/icons/clock-icon.svg';
import { ReactComponent as sun } from 'resources/icons/sun.svg';
import { ReactComponent as shield } from 'resources/icons/shield-lock.svg';
import { ReactComponent as internet } from 'resources/icons/internet.svg';
import { ReactComponent as lock } from 'resources/icons/lock.svg';
import { ReactComponent as leftRightArrow } from 'resources/icons/left-right-arrow.svg';
import { ReactComponent as moon } from 'resources/icons/moon.svg';
import { ReactComponent as toggle } from 'resources/icons/toggle.svg';
import { ReactComponent as setting } from 'resources/icons/setting.svg';
import { ReactComponent as arrowDown } from 'resources/icons/arrow-down.svg';
import { ReactComponent as arrowLeft } from 'resources/icons/arrow-left.svg';
import { ReactComponent as left } from 'resources/icons/left.svg';
import { ReactComponent as right } from 'resources/icons/right.svg';
import { ReactComponent as search } from 'resources/icons/search.svg';
import { ReactComponent as greenCheck } from 'resources/icons/green-check-solid.svg';
import { ReactComponent as information } from 'resources/icons/information-solid.svg';
import { ReactComponent as threeRightArrow } from 'resources/icons/three-right-arrow.svg';
import { ReactComponent as grayThinLine } from 'resources/icons/gray-thin-line.svg';
import { ReactComponent as blueSolidLine } from 'resources/icons/blue-solid-line.svg';
import { ReactComponent as unfilledCircle } from 'resources/icons/unfilled-circle.svg';
import { ReactComponent as assetSelector } from 'resources/icons/asset-selector.svg';

// chain data icons
import { ReactComponent as Blocks } from 'resources/icons/chain/blocks.svg';
import { ReactComponent as Sign } from 'resources/icons/chain/sign.svg';
import { ReactComponent as transfer } from 'resources/icons/chain/switch.svg';
import { ReactComponent as holder } from 'resources/icons/chain/holders.svg';
import { ReactComponent as total } from 'resources/icons/chain/total.svg';
import { ReactComponent as staked } from 'resources/icons/chain/staked.svg';
import { ReactComponent as validator } from 'resources/icons/chain/validator.svg';
import { ReactComponent as rate } from 'resources/icons/chain/rate.svg';

// extrinsic icons
import { ReactComponent as success } from 'resources/icons/success.svg';
import { ReactComponent as copy } from 'resources/icons/copy.svg';
import { ReactComponent as copySquare } from 'resources/icons/copy-square.svg';
import { ReactComponent as copySquareGrey } from 'resources/icons/copy-square-grey.svg';
import { ReactComponent as flower } from 'resources/icons/flower.svg';
import { ReactComponent as polkadot } from 'resources/icons/polkadot.svg';
import { ReactComponent as dropUp } from 'resources/icons/drop-up.svg';
import { ReactComponent as dropDown } from 'resources/icons/drop-down.svg';
import { ReactComponent as detail } from 'resources/icons/detail.svg';
import { ReactComponent as user } from 'resources/icons/user.svg';
import { ReactComponent as key } from 'resources/icons/key.svg';
import { ReactComponent as warning } from 'resources/icons/warning.svg';
import { ReactComponent as arrowRight } from 'resources/icons/arrow-right.svg';
import { ReactComponent as cancel } from 'resources/icons/cancel.svg';
import { ReactComponent as heart } from 'resources/icons/heart.svg';
import { ReactComponent as upDownArrow } from 'resources/icons/up-down-arrow.svg';
import { ReactComponent as txSuccess } from 'resources/icons/tx-success.svg';
import { ReactComponent as txFailed } from 'resources/icons/tx-failed.svg';
import { ReactComponent as txPending } from 'resources/icons/tx-pending.svg';
import { ReactComponent as successIcon } from 'resources/icons/success-icon.svg';
import { ReactComponent as failedIcon } from 'resources/icons/failed-icon.svg';

// links icons
import { ReactComponent as MantaWebsite } from 'resources/icons/links/MantaWebsite.svg';
import { ReactComponent as CalamariWebsite } from 'resources/icons/links/CalamariWebsite.svg';
import { ReactComponent as twitter } from 'resources/icons/links/Twitter.svg';
import { ReactComponent as Discord } from 'resources/icons/links/Discord.svg';
import { ReactComponent as Telegram } from 'resources/icons/links/Telegram.svg';
import { ReactComponent as Medium } from 'resources/icons/links/Medium.svg';
import { ReactComponent as Docs } from 'resources/icons/links/Docs.svg';
import { ReactComponent as BugReport } from 'resources/icons/links/BugReport.svg';

import { ReactComponent as activityRightArrow } from 'resources/icons/activity-right-arrow.svg';
import { ReactComponent as Info } from 'resources/icons/info.svg';
import { ReactComponent as copySquareWhite } from 'resources/icons/copy-square-white.svg';

import { ReactComponent as assethub } from 'resources/icons/chain/assethub.svg';

const icons = {
  assethub,
  calamari,
  calamariLogo,
  manta,
  talisman,
  metamask,
  subwallet,
  bitcoin,
  ethereum,
  acala,
  kusama,
  ausd,
  kar,
  kbtc,
  roc,
  movr,
  moonbeam,
  tether,
  dai,
  usdc,
  wbtc,
  bnb,
  statemine,
  audit,
  close,
  govern,
  pool,
  redeem,
  swap,
  transact,
  token,
  deposit,
  rowDown,
  rowDownWhite,
  coin,
  wallet,
  clock,
  sun,
  shield,
  internet,
  lock,
  leftRightArrow,
  moon,
  toggle,
  setting,
  arrowDown,
  arrowLeft,
  left,
  right,
  search,
  greenCheck,
  information,
  unfilledCircle,
  Blocks,
  Sign,
  transfer,
  holder,
  total,
  staked,
  validator,
  rate,
  success,
  copy,
  copySquare,
  copySquareGrey,
  copySquareWhite,
  flower,
  polkadot,
  dropUp,
  dropDown,
  detail,
  user,
  Info,
  key,
  warning,
  arrowRight,
  cancel,
  heart,
  upDownArrow,
  assetSelector,
  txSuccess,
  txFailed,
  txPending,
  grayThinLine,
  blueSolidLine,
  threeRightArrow,
  MantaWebsite,
  CalamariWebsite,
  Twitter: twitter,
  Discord,
  Telegram,
  Medium,
  Docs,
  BugReport,
  activityRightArrow,
  warningV2,
  successIcon,
  failedIcon
};
export default icons;
